import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { typesOfWork } from '../../actions/currentPerformance';
import getFileIcon from '../../utils/getFileIcon';

class ResultsFiles extends Component {

  state = {
    isShow: false,
    file: null
  }

  handleDownloadFile = file => () => {
    const { download, type, row } = this.props;
    const { sheid, instance } = row;
    download(file.file, sheid, instance, type, 'result');
  };

  handleRemoveFile = () => {
    const fileToRemove = this.state.file;
    const { deleteFile, type, row: { sheid, instance } } = this.props;
    deleteFile(fileToRemove, sheid, instance, type, 'result')
    this.setState({ file: null, isShow: null });
  };

  handleNoRemoveFile = () => {
    this.setState({ file: null, isShow: null });
  }

  handleConf = (e) => {
    this.setState({ file: e.target.getAttribute('data-file'), isShow: true });
  }

  handleUploadFile = e => {
    const { uploadFile, type, row, userId } = this.props;
    const { sheid, instance } = row;
    const { files } = e.target
    files && uploadFile(files[0], sheid, instance, type, 'result', userId);  /// TODO 
    // files && uploadFile(files[0], sheid, instance, type, type === 'group' ? typesOfWork.RESULT_WORK_GROUP : typesOfWork.RESULT_WORK_IND);
  };

  createFileAt = () => {
    const fileInput = document.getElementById('fileInput')
    fileInput.click()
  }

  renderFile = (file, index) => {
    return (<tr key={index}>
      <td className="td-center" width="20%">
        <img alt={"icon"} src={getFileIcon(file.file)} />
      </td>
      <td width="75%">
        <a role="button" onClick={this.handleDownloadFile(file)}>{file.file}</a>
      </td>
      <td className="td-right" width="5%">
        <a role="button" data-file={file.file} onClick={this.handleConf}>Удалить</a>
      </td>
    </tr>)
  };

  render() {
    const { handleCloseModal, modalData, type, modalTarget } = this.props;

    return (
      <div className="tasks-files">
        {
          this.state.isShow ?
            <div className='modalConfWrapper' id='popup'>
              <div className='modalConf'>
                <h3>Удалить файл?</h3>
                <button className='modalConfButYes' onClick={this.handleRemoveFile}>Да</button>
                <button className='modalConfButNo' onClick={this.handleNoRemoveFile}>Нет</button>
              </div>
            </div>
            :
            ''
        }
        <div className="captions">Файлы результата работы</div>
        <table>
          <tbody>
            {modalData?.map(this.renderFile)}
            {/* {resultIndStudent?.map(this.renderFile)} */}
          </tbody>
        </table>
        <div className="buttons_panel">
          <div className="left__panel">
            <FileUploadButton createFileAt={this.createFileAt} uploadFile={this.handleUploadFile} />
          </div>
          <div className="right__panel">
            <a role="button" onClick={handleCloseModal}>Закрыть</a></div>
        </div>
      </div>
    );
  }
}

const ResultsFilesForm = reduxForm({ form: 'tasks-files-results' })(ResultsFiles);

export default ResultsFilesForm;



const FileUploadButton = ({ createFileAt, uploadFile }) => {
  return (
    <button onClick={createFileAt} className='updateButton' style={{ marginTop: '10px', position: 'relative', left: '75px' }}>
      <input
        type="file"
        id='fileInput'
        onChange={uploadFile}
        hidden
      />
      Выбрать файл
    </button>
  )
}